import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { isLogin } from "../../utils/index";
import Loader from "../Loader";
import { getFirstAvailablePath } from "../../utils/navigationPermissionsUtil";
// images
import EyeOn from "../../Assets/eye-on.svg";
import EyeOff from "../../Assets/eye-off.svg";

// -- redux
import { connect } from "react-redux";
import { Login } from "../../Redux/Actions/LoginAction";

function LoginForm(props) {
  const [show, setShow] = useState(false); //Toggles password eye to on/off state
  const [hide, setHide] = useState(false); //Used to hide or show error message block
  const [email, setEmail] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [bankError, setBankError] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (bankCode === "") {
      setBankError("Invalid bank code.");
      return;
    } else setBankError("");

    //let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    let emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;
    if (emailRegex.test(email)) {
      setEmailError("");
      const data = { email: email, password: password, bankcode: bankCode };
      setHide(true);
      setTimeout(function () {
        setHide(false);
      }, 5000);
      props.Login(data);
    } else {
      setEmailError("Invalid email");
    }
  };

  useEffect(() => {
    if (isLogin() && getFirstAvailablePath() === "") {
      sessionStorage.clear();
      setEmailError("No modules assigned to this email address.");
      setTimeout(function () {
        setEmailError("");
      }, 5000);
      return;
    }
    props.data && props.data.status === 200 && isLogin() && props.history.push(getFirstAvailablePath());
  }, [props]);

  useEffect(() => {
    if (props?.data?.response?.data?.error) setEmailError("Invalid login.");
  }, [props]);

  return (
    <>
      {props.loading && <Loader />}
      <form className="mt-4" onSubmit={(e) => submit(e)}>
        <div className="mt-3 text-left">
          <label className="text-white w-100 mb-0" htmlFor="bankCode">
            <p className="mb-0 f-12">Bank Code</p>
            <input id="bankCode" type="text" placeholder="Your bank code" autoComplete="off" className={bankError ? "form-input-danger form-input f-14 mt-1 pb-1 text-white" : "form-input f-14 mt-1 pb-1 text-white"} onChange={(e) => setBankCode(e.target.value)} value={bankCode} />
          </label>
          {bankError && <span className="f-12 text-danger">{bankError}</span>}
        </div>
        <div className="mt-3 text-left">
          <label className="text-white w-100 mb-0" htmlFor="email">
            <p className="mb-0 f-12">Email</p>
            <input id="email" type="text" placeholder="Your email" autoComplete="off" className={emailError ? "form-input-danger form-input f-14 mt-1 pb-1 text-white" : "form-input f-14 mt-1 pb-1 text-white"} onChange={(e) => setEmail(e.target.value)} value={email} />
          </label>
          {emailError && <span className="f-12 text-danger">{emailError}</span>}
        </div>
        <div className="mt-3 position-relative text-left">
          <label className="text-white w-100" htmlFor="password">
            <p className="mb-0 f-12">Password</p>
            <input id="password" type={show ? "text" : "password"} placeholder="Your password" className="form-input f-14 mt-1 pb-1 text-white" onChange={(e) => setPassword(e.target.value)} value={password} autoComplete="off" />
            <img onClick={() => setShow(!show)} className="InputIcon cursor-pointer" src={show ? EyeOn : EyeOff} alt="EyeOn" />
          </label>
          {props.data && props.data.response && hide && <p className="f-12 text-danger">{props.data.response.status === 401 ? props.data.response.data.message : ""}</p>}
          {props.data && hide && <p className="f-12 text-danger">{props.data.status === 402 ? props.data.message : props.data.data && props.data.data.password}</p>}
        </div>
        <div className="text-right mt-3">
          <Link to="/forgot-password" className="text-white cursor-pointer">
            Forgot password
          </Link>
        </div>
        <button onClick={(e) => submit(e)} type="submit" className="form-button f-14 mt-4Center centerMargin" disabled={!(email && password && bankCode)}>
          login
        </button>
      </form>
    </>
  );
}

const mapStateToProps = ({ LoginReducer }) => {
  const { loading, data } = LoginReducer;
  return { loading, data };
};

const mapDispatchToProps = {
  Login,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm));
